<template>
  <div class="header">
  	<div class="container">
  		<a href="/?from=login"><img src="../../assets/image/index/logo.png" class="logo"></a>
  		<div class="qrcode" @mouseover="qrcodePopupShow=true"  @mouseout="qrcodePopupShow=false">
  			<img src="../../assets/image/index/qrcode.png" class="icon">
  			<span>关注人民党建云</span>
  			<div class="qrcode-popup" v-show="qrcodePopupShow">
  				<img src="../../assets/image/index/qrcode111.png">
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
export default {
  name: 'djy-header',
  data() {
  	return {
  		qrcodePopupShow: false
  	}
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	
	.header {
		height: 56px;
		background: #FFFFFF;
	}
	
	.header .container {
		width: 1120px;
		margin: 0 auto;
		position: relative;
	    height: 56px;
	}
	
	.header .container .logo {
		width: 107px;
		height: 26px;
		margin-top: 13px;
		vertical-align: middle;
		float: left;
	    margin-left: 40px;
	}
	
	.header .container .qrcode {
		float: right;
		/* line-height: 56px; */
		position: relative;
		cursor: pointer;
	    margin-right: 40px;
	}
	
	.header .container .qrcode .icon {
		width: 14px;
		height: 14px;
		margin-right: 10px;
		margin-top: 21px;
		float: left;
	}
	
	.header .container .qrcode span {
		display: block;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #282828;
		line-height: 12px;
		margin-top: 22px;
		float: left;
	}
	.qrcode-popup{
		width: 105px;
		height: 109px;
		position: absolute;
		background: url(~@/assets/image/index/qrcodeBG.png);
		background-repeat: no-repeat;
		background-size: cover;
		z-index: 3;
		text-align: center;
		top: 37px;
		right: 10px;
	}
	.qrcode-popup img{
		width: 95px;
		height: 95px;
		margin-top: 9px;
	}
	
</style>
